export enum JobAttachmentType {
    Image = 0,
    Pdf = 1,
}
